import React, { useEffect } from 'react'
import cx from 'classnames'
import { Icon, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { billing, UpgradeSource } from 'common/billing'
import {
  getIsEnableNewCtaOnBar,
  getUpgradeCaption,
} from 'common/billing/entities/upgradeRequest/selectors'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const ExpiredAccountNotification = () => {
  useEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.EXPIRED.SHOWN')
  }, [])

  const handleClick = () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.EXPIRED.CLICKED')
    billing.requestUpgrade({ source: UpgradeSource.EXPIRED_NOTIFY_BAR })
  }

  const isEnableNewCtaOnBar = useAppSelector(getIsEnableNewCtaOnBar)

  const text = l.translate(
    'Your subscription has expired and your account is now on the Free plan. Upgrade to continue use automations with paid features.',
  )

  const upgradeCaption = useAppSelector(getUpgradeCaption)

  return (
    <>
      <span>{text}</span>
      <a target="_blank" className={cx(cm.more, cm.expired, 'm-l-xs')} onClick={handleClick}>
        {isEnableNewCtaOnBar && <Icon.Renew className={cm.icon} />}
        {upgradeCaption}
      </a>
    </>
  )
}
